export type HandleDateFormat = 'datetime' | 'date' | 'input'

const OFFSET_BRT_MS = 1.08e7

const pad = (value: number) => `${value}`.padStart(2, '0')

const handleDate = (
    date: Date,
    format: HandleDateFormat = 'datetime',
    applyOffset = false
) => {
    const novaData = new Date(date.toISOString().replace(/\.\d{3}Z$/, ''))
    const adjusted = applyOffset
        ? new Date(novaData.getTime() - OFFSET_BRT_MS)
        : novaData

    if (format === 'date') return adjusted.toLocaleDateString()
    if (format === 'input') {
        return `${adjusted.getFullYear()}-${pad(adjusted.getMonth() + 1)}-${pad(adjusted.getDate())}T${pad(adjusted.getHours())}:${pad(adjusted.getMinutes())}`
    }

    return adjusted.toLocaleString()
}

export default handleDate
